/**
 * 達成時の効果音再生ユーティリティ
 * public/sounds/ 以下の音声ファイルを再生します。
 */

const SOUND_PATH = '/sounds/success-221935.mp3';

let audioCache: HTMLAudioElement | null = null;

export const preloadSuccessSound = (): void => {
  try {
    audioCache = new Audio(SOUND_PATH);
    audioCache.preload = 'auto';
    audioCache.load();
  } catch (error) {
    console.error('[Sound] Preload failed:', error);
  }
};

export const playSuccessSound = async (volume: number = 0.5): Promise<void> => {
  try {
    const audio = audioCache ? (audioCache.cloneNode() as HTMLAudioElement) : new Audio(SOUND_PATH);
    audio.volume = volume;
    await audio.play();
  } catch (error) {
    console.error('[Sound] Play failed:', error);
  }
};

// 初期化
preloadSuccessSound();

export default playSuccessSound;
